export default function PokerRules({ show, onClose }) {
    if (!show) return null;

    return (
        <>
            <style>
                {`
                    h1{
                        font-size: 40px;
                        font-weight: 800;
                    }
                    h2{
                        font-size: 32px;
                    }
                    h3 {
                        font-size: 28px;
                    }
                    p{
                        font-size: 15px;
                        font-weight: 500;
                    }    
                    .modal-header {
                        background-color: #fff;
                        color: #000;
                        padding: 1rem;
                        display: flex;
                        align-items: center;
                        max-width: 100% !important;
                        width: 100%
                    }
                    .modal-content {
                        max-width: 920px;
                        max-height: 100vh;
                        margin-top: 25px;
                        background-color: #fff;
                        color: #000;
                        border-radius: 8px;
                        margin-left: auto; 
                        margin-right: auto; 
                        width: 100% !important;
 
                    }
                    .imgt20 {
                        max-width: 100%;  
                        height: auto;     
                        display: block;
                    }
                `}
            </style>

            <div class="modal fade show" id="modalMarketRules" tabindex="-1" role="dialog" aria-labelledby="modalMarketRules" style={{ display: "block", paddingLeft: "0px", marginBottom: "10px" }}>
                <div class="modal-dialog modal-lg" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel">Market Rules</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close" onClick={onClose}>
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div id="market-rules-text" class="modal-body">

                            <div>
                                <div>
                                    <center>
                                        <h1><b>Poker</b></h1>
                                        <h2>Rules and Regulations</h2>
                                        <hr></hr>
                                        <div>
                                            <h3><b>GAME OBJECTIVES</b></h3>
                                            <p class="pt20">To predict whether the Player A or Player B will get a better hand.</p>
                                        </div>

                                        <div>
                                            <h3><b>GAME RULES</b></h3>
                                            <p class="pt20"><b> Hands Dealt:</b>2 (2 cards for Player A, 2 cards for Player B, 5 Common cards)</p>
                                            <p class="pt20"><b>Bets</b>: Highest hand wins. Ranking from High to Low is:</p>
                                        </div>

                                        <div>
                                            <div>
                                                <center><h3>PAYOUTS</h3></center>
                                                <div>
                                                    <p class="pt20">Payout as per the bet placed. </p>
                                                    <table class="table table-bordered table-sm">
                                                        <tbody>
                                                            <tr>
                                                                <th>Player A</th>
                                                                <th>
                                                                    1 to 0.98
                                                                </th>
                                                            </tr>
                                                            <tr>
                                                                <th>PlayerB</th>
                                                                <th>
                                                                    1 to 0.98
                                                                </th>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                    <div>
                                                        <p class="pt20">
                                                            Pair plus market payout
                                                        </p>
                                                    </div>
                                                </div>
                                                <div>
                                                    <table class="table table-bordered table-sm">
                                                        <tbody>
                                                            <tr>
                                                                <th>One Pair</th>
                                                                <th>
                                                                    1 to 1
                                                                </th>
                                                            </tr>
                                                            <tr>
                                                                <th>Two Pair</th>
                                                                <th>
                                                                    1 to 2.75
                                                                </th>
                                                            </tr>

                                                            <tr>
                                                                <th>Three of a kind</th>
                                                                <th>
                                                                    1 to 15
                                                                </th>
                                                            </tr>

                                                            <tr>
                                                                <th>Straight</th>
                                                                <th>
                                                                    1 to 15
                                                                </th>
                                                            </tr>

                                                            <tr>
                                                                <th>Flush</th>
                                                                <th>
                                                                    1 to 25
                                                                </th>
                                                            </tr>

                                                            <tr>
                                                                <th>Full House</th>
                                                                <th>
                                                                    1 to 28
                                                                </th>
                                                            </tr>
                                                            <tr>
                                                                <th>Four of a Kind</th>
                                                                <th>
                                                                    1 to 250
                                                                </th>
                                                            </tr>
                                                            <tr>
                                                                <th>Straight flush</th>
                                                                <th>
                                                                    1 to 500
                                                                </th>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                    <div>
                                                        <img class="imgt20" alt="poker" src="https://www.bpexch.live/img/pokerrules.jpg" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </center>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}